document.addEventListener('DOMContentLoaded', () => {
  const selectors = [
    '.swiper-slide-duplicate'
  ].map(sel => `${sel} h1, ${sel} h2, ${sel} h3, ${sel} h4, ${sel} h5, ${sel} h6`).join(', ');

  function replaceDuplicateHeadings() {
    document.querySelectorAll(selectors).forEach(header => {
      if (header.tagName.toLowerCase() === 'p') return;

      const p = document.createElement('p');
      p.className = header.className;
      p.innerHTML = header.innerHTML;
      header.replaceWith(p);
    });
  }

  replaceDuplicateHeadings();

  const observer = new MutationObserver(() => replaceDuplicateHeadings());
  observer.observe(document.body, { childList: true, subtree: true });
});

function replaceHeadingsInDrawer() {
  const selector = '.mobile-drawer.enters-upwards h3, .mobile-drawer.enters-upwards h4';
  document.querySelectorAll(selector).forEach(header => {
    const p = document.createElement('p');
    p.className = header.className;
    p.innerHTML = header.innerHTML;
    header.replaceWith(p);
  });
}
document.addEventListener('DOMContentLoaded', replaceHeadingsInDrawer);